"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _buttons = require("@site/buttons");
var _domainServices = require("@site/domain-services");
var _button = _interopRequireDefault(require("@ux/button"));
var _spinner = _interopRequireDefault(require("@ux/spinner"));
var _reactMintl = require("@godaddy/react-mintl");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _addToCart = _interopRequireDefault(require("@ux/icon/add-to-cart"));
var _remove = _interopRequireDefault(require("@ux/icon/remove"));
var _utils = require("@site/utils");
/* eslint-disable complexity */

const DEFAULT_TERM = '12:Month';
const BundleAddToCartButton = ({
  // State To Render The Button in (Remove or Add)
  productInCart = false,
  // Product Specific Data to be used in SAPI Post.
  domain = {},
  product = {},
  apiKey = 'dpp_search',
  trackingCode = '',
  plid = '1',
  market = '',
  basketId = '',
  additionalPackageAttributes = {},
  additionalPostDataAttributes = {},
  env = (0, _utils.getEnv)(window.location.href),
  resellerBaseOverride,
  // UX / UI Related.
  buttonClassNameOverride = '',
  addProps = {},
  removeProps = {},
  verifyingProps = {},
  removingProps = {},
  ContinueToCartComponent,
  version = 1,
  isMobile = false,
  // Event to use when Cart states change.
  onCartStateChange = () => {},
  addToCartText = ''
}) => {
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const products = [{
    ...product,
    packageIdOverride: 'domain-bundle',
    term: product.term || DEFAULT_TERM
  }];
  const statusTextStyle = {
    'font-size': '0.3rem',
    'max-width': '8px'
  };
  const isVersionOne = version === 1;
  const sapiPostData = (0, _domainServices.constructSapiPost)({
    trackingCode,
    products,
    additionalPackageAttributes,
    additionalPostDataAttributes
  });
  const getClassNames = (defaults = '') => {
    return buttonClassNameOverride || defaults;
  };
  const AddToCart = ({
    onManagerActionOrStateChange
  }) => {
    const defaultAddClassNames = (0, _classnames.default)('btn-filled btn-link ux-button-small spin-buy-button add-to-cart rounded', {
      'mr-4': isVersionOne && !isMobile
    });
    return isVersionOne ? /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
      "aria-label": formatMessage({
        id: addToCartText || 'dppSolutionsBuyButtonTextAdd'
      }),
      "data-cy": `${domain.BundleGUID}_stack_bundle_add_to_cart_button`,
      className: getClassNames(defaultAddClassNames),
      onClick: onManagerActionOrStateChange,
      icon: /*#__PURE__*/_react.default.createElement("div", {
        "data-cy": "add-to-cart-icon-uxcore",
        "data-testid": "add-to-cart-icon-uxcore",
        "aria-hidden": true
      }, /*#__PURE__*/_react.default.createElement(_addToCart.default, {
        fill: "black",
        width: 28,
        height: 28
      }))
    }, addProps)) : /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
      "data-cy": `${domain.BundleGUID}_stack_bundle_add_to_cart_button`,
      "data-testid": "stack-bundle-add-to-cart-secondary-design",
      className: getClassNames(defaultAddClassNames),
      onClick: onManagerActionOrStateChange,
      design: "secondary",
      text: formatMessage({
        id: addToCartText || 'dppSolutionsBuyButtonTextAdd'
      })
    }, addProps));
  };
  AddToCart.propTypes = {
    onManagerActionOrStateChange: _propTypes.default.func
  };
  const VerifyingCart = () => {
    const defaultVerifyingClassNames = 'btn-filled btn-link ux-button-small spin-buy-button add-to-cart cursor-inherit mr-4';
    const textId = 'addingToCart';
    return isVersionOne ? /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
      className: getClassNames(defaultVerifyingClassNames),
      text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "d-inline-flex justify-content-center"
      }, /*#__PURE__*/_react.default.createElement(_spinner.default, {
        size: "md"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "text-white",
        style: statusTextStyle
      }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
        id: textId
      })))
    }, verifyingProps)) : /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: textId
    });
  };
  const RemoveFromCart = ({
    onManagerActionOrStateChange
  }) => {
    const defaultRemoveClassNames = (0, _classnames.default)('btn-filled btn-link ux-button-small spin-buy-button add-to-cart cursor-inherit rounded', {
      'mr-4': isVersionOne
    });
    const RemoveFromCartButton = () => isVersionOne ? /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
      className: getClassNames(defaultRemoveClassNames),
      "data-cy": `${domain.BundleGUID}_stack_bundle_remove_from_cart_button`,
      onClick: onManagerActionOrStateChange,
      icon: /*#__PURE__*/_react.default.createElement("div", {
        "data-cy": "add-to-cart-icon-uxcore",
        "aria-hidden": true
      }, /*#__PURE__*/_react.default.createElement(_remove.default, {
        fill: "black",
        width: 28,
        height: 28
      }))
    }, removeProps)) : /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
      className: getClassNames(defaultRemoveClassNames),
      "data-cy": `${domain.BundleGUID}_stack_bundle_remove_from_cart_button`,
      onClick: onManagerActionOrStateChange,
      design: "secondary"
    }, removeProps), /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "remove"
    }));
    return ContinueToCartComponent ? /*#__PURE__*/_react.default.createElement(ContinueToCartComponent, {
      domain: domain
    }) : /*#__PURE__*/_react.default.createElement(RemoveFromCartButton, null);
  };
  RemoveFromCart.propTypes = {
    onManagerActionOrStateChange: _propTypes.default.func
  };
  const RemovingFromCart = () => {
    const textId = 'dppSolutionsRemoving';
    const defaultRemovingClassNames = 'btn-filled btn-link ux-button-small spin-buy-button add-to-cart cursor-inherit mr-4';
    return isVersionOne ? /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
      className: getClassNames(defaultRemovingClassNames),
      text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "d-inline-flex justify-content-center"
      }, /*#__PURE__*/_react.default.createElement(_spinner.default, {
        size: "md"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "text-white",
        style: statusTextStyle
      }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
        id: textId
      })))
    }, removingProps)) : /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: textId
    });
  };
  const FailedCtaComponent = () => {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h6", {
      "data-cy": "unavailable_message"
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "domainFailedAvailCheck"
    })));
  };
  return /*#__PURE__*/_react.default.createElement(_buttons.AddToCartManager, {
    onCartStateChange: onCartStateChange,
    ctaComplete: productInCart,
    sapiPostData: sapiPostData,
    trackingCode: trackingCode,
    plid: plid,
    basketId: basketId,
    apiKey: apiKey,
    market: market,
    env: env,
    resellerBaseOverride: resellerBaseOverride,
    customComponents: {
      CustomAddToCartComponent: AddToCart,
      CustomRemoveFromCartComponent: RemoveFromCart,
      CustomRunningComponent: VerifyingCart,
      CustomRevertingComponent: RemovingFromCart,
      CustomFailureComponent: FailedCtaComponent
    }
  });
};
BundleAddToCartButton.propTypes = {
  domain: _propTypes.default.object,
  product: _propTypes.default.shape({
    name: _propTypes.default.string,
    packageIdOverride: _propTypes.default.string,
    term: _propTypes.default.string,
    phase: _propTypes.default.string,
    redemptioncode: _propTypes.default.string
  }),
  apiKey: _propTypes.default.string,
  trackingCode: _propTypes.default.string,
  productInCart: _propTypes.default.bool,
  plid: _propTypes.default.string,
  market: _propTypes.default.string,
  basketId: _propTypes.default.string,
  additionalPackageAttributes: _propTypes.default.object,
  additionalPostDataAttributes: _propTypes.default.object,
  buttonClassNameOverride: _propTypes.default.string,
  addProps: _propTypes.default.object,
  removeProps: _propTypes.default.object,
  verifyingProps: _propTypes.default.object,
  removingProps: _propTypes.default.object,
  onCartStateChange: _propTypes.default.func,
  ContinueToCartComponent: _propTypes.default.func,
  version: _propTypes.default.number,
  env: _propTypes.default.string,
  resellerBaseOverride: _propTypes.default.string,
  isMobile: _propTypes.default.bool,
  addToCartText: _propTypes.default.string
};
var _default = exports.default = BundleAddToCartButton;